import {Component, Inject, OnInit} from '@angular/core';
import {environment} from "../../../../environments/environment";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {StorageService} from "../../../modules/auth/services/storage.service";
import {HttpClient} from "@angular/common/http";
import {MatIcon} from "@angular/material/icon";
import {MatRadioButton, MatRadioGroup} from "@angular/material/radio";
import {FormsModule} from "@angular/forms";
import {NgForOf, NgIf} from "@angular/common";
import {MatButton} from "@angular/material/button";



export interface ProfileSelectionDialogData {
    userId: string;
    parentId: string;
    showMyProfile: boolean;
}

export interface Child {
    id: string;
    first_name: string;
    last_name: string;
}

export interface ProfileOption {
    id: string;
    name: string;
    type: 'myProfile' | 'childProfile';
    description: string;
    first_name?: string;
    last_name?: string;
}
@Component({
  selector: 'app-profile-selection-dialog',
  standalone: true,
    imports: [
        MatIcon,
        MatRadioGroup,
        MatRadioButton,
        FormsModule,
        NgForOf,
        NgIf,
        MatButton
    ],
  templateUrl: './profile-selection-dialog.component.html',
  styleUrl: './profile-selection-dialog.component.scss'
})
export class ProfileSelectionDialogComponent implements OnInit {
    children: Child[] = [];
    selectedOption: ProfileOption | null = null;
    loading = true;
    myProfileOption: ProfileOption;

    constructor(
        public dialogRef: MatDialogRef<ProfileSelectionDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ProfileSelectionDialogData,
        private http: HttpClient,
        private storageService: StorageService
    ) {
        // Initialiser l'option "Mon profil" seulement si showMyProfile est true
        if (this.data.showMyProfile) {
            const userInfo = this.storageService.getUserInfo();
            console.log("userInfouserInfo",userInfo);
            this.myProfileOption = {
                id: this.data.userId,
                name: 'Mon profil joueur',
                type: 'myProfile',
                description: 'Voir votre propre profil',
                first_name: userInfo?.first_name || 'Mon',
                last_name: userInfo?.last_name || 'Profil'
            };
        }
    }

    ngOnInit(): void {
        this.loadChildren();
    }

    private loadChildren(): void {
        const clubId = this.getClubId();

        this.http.get<Child[]>(`${environment.apiNest_2}/api/v1/users/parent/${this.data.parentId}/children`, {
            headers: { 'x-club-id': clubId }
        }).subscribe({
            next: (children) => {
                this.children = children;
                this.loading = false;
            },
            error: (error) => {
                console.error('Erreur lors du chargement des enfants:', error);
                this.children = [];
                this.loading = false;
            }
        });
    }

    private getClubId(): string {
        const userInfo = this.storageService.getUserInfo();
        return userInfo?.activeClubId || '';
    }

    /**
     * Crée un objet ProfileOption pour un enfant
     */
    createChildOption(child: Child): ProfileOption {
        return {
            id: child.id,
            name: `${child.first_name} ${child.last_name}`,
            type: 'childProfile',
            description: 'Profil joueur'
        };
    }

    getInitials(firstName: string, lastName: string): string {
        return `${firstName?.charAt(0) || ''}${lastName?.charAt(0) || ''}`.toUpperCase();
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onConfirm(): void {
        if (this.selectedOption) {
            if (this.selectedOption.type === 'myProfile') {
                this.dialogRef.close({ action: 'myProfile' });
            } else {
                this.dialogRef.close({
                    action: 'childProfile',
                    selectedChildId: this.selectedOption.id
                });
            }
        }
    }
}
